// @flow
import React, { useMemo, type Node } from 'react';
import { path } from 'ramda';
import { useTranslation } from 'react-i18next';

import { Api, createApiData } from 'app/common/context/Api';


export const MenuDishes = createApiData();

const makeRequestsData = (id, date, sellPointId, t, schoolId) => ((id && date && sellPointId) ? {
  menuDishes: {
    path: 'cafeteria/customer/menu/items',
    type: 'get',
    rest: {
      params: {
        customer_id: id,
        school_id: schoolId,
        date,
        ...(sellPointId ? { sale_point_id: sellPointId } : {}),
      },
    },
    cbErrorTextCreate: (error) => {
      const message = path(['response', 'data', 'message'], error);
      if (message === 'Not found sale point') return '';
      return t(
        'menu_dishes_fetch_error',
        'Не удалось получить блюда меню столовой',
      );
    },
    autoRequest: true,
  },
} : {});

export type DishApiType = {
  available: boolean,
  category_id: number,
  cost: number,
  guid: string,
  image?: string,
  portion: string,
  title: string,
}

type State = {
  content: {
    items: {
      [string]: DishApiType,
    },
  },
  loading: boolean,
  request: {
    menuDishes: () => Promise<void>,
  },
  error?: { [string]: mixed },
}

type Props = {
  personId?: number,
  sellPointId?: number | null,
  date?: string,
  children: Node | (value: State) => Node,
  schoolId?: number,
}

const initialContent = {
  items: {},
};

const MenuDishesApi = ({ children, personId, sellPointId, date, schoolId }: Props) => {
  const { t } = useTranslation('cafeteria');
  const descriptions = useMemo(
    () => makeRequestsData(personId, date, sellPointId, t, schoolId),
    [personId, date, sellPointId, t, schoolId],
  );

  return (
    <Api apiData={MenuDishes} descriptions={descriptions} initialContent={initialContent}>
      {children}
    </Api>
  );
};

export default MenuDishesApi;
